import { Nullable } from "@core/domain/types/nullable.type";
import { FinancialEntityBudget } from "@project/domain/models/budget/financial-entity-budget.model";

export class CreateFinancialEntityBudget {
    constructor(
        public name: FinancialEntityBudget["name"],
        public description: FinancialEntityBudget["description"],
        public financialEntityId: Nullable<
            FinancialEntityBudget["financialEntityId"]
        >,
        public justificationTemplateId?: number | null,
        public isTemplate?: boolean,
        public includesIndirectCosts?: boolean,
    ) {}
}
